<template>
  <div v-show="showContent">
    <GlobalLoader v-if="fullLoader"/>
    <farmacloud-header-bar
      v-if="showTopbar"
      ref="topbarRef"
      id="farmacloud-header-bar"
      v-bind="topbarProps"
      :data-env="topbarEnv"
      :data-help="helpButton ? 'true' : 'false'"
      :data-config="hasSettingsShell && showConfigButton ? 'true' : 'false'"
      :data-primarycolor="primaryColor"
      data-initialstate="hide"
    />
    <router-view
      @click-nav="onClickNav"
      @click-logout="onClickLogout"
    />
    <image-finder
      v-if="showImageFinder"
      :key="resetKey"
    />
    <settings-shell
      v-if="hasSettingsShell"
      :key="resetKey"
      :model-value="settingsShell"
      :settings="settingsItemId"
      @update:model-value="updateSettingsShellState"
      @update:settings="updateSettingsShellItemId"
    />
    <slot :resetKey="resetKey" />
  </div>
</template>

<script>
import ImageFinder from '@/components/ImageFinder'
import SettingsShell from '@/components/SettingsShell'
import GlobalLoader from '@/components/GlobalLoader'
import { useShellApp, useTopbar, useSettingsShell } from '@/composables'
import { Auth, colors } from '@/dashboards'
import { storeToRefs } from 'pinia'
import { useShellStore } from '@/store'

export default {
  components: { ImageFinder, SettingsShell, GlobalLoader },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    showImageFinder: {
      type: Boolean,
      default: false
    },
    showSettingShell: {
      type: Boolean,
      default: false
    },
    showConfigButton: {
      type: Boolean,
      default: true
    },
    helpButton: {
      type: Boolean,
      default: false
    },
    disableTopbar: {
      type: Boolean,
      default: false
    },
    topbarProps: {
      type: Object,
      default: () => ({})
    }
  },
  setup (props, { emit }) {
    const { showContent, micro } = useShellApp(props)
    const { settingsShell, settingsItemId, updateSettingsShellState, updateSettingsShellItemId, hasSettingsShell } = useSettingsShell(props)
    const { showTopbar, topbarRef, topbarEnv, resetKey } = useTopbar({
      ...props,
      showConfigButton: props.showConfigButton && hasSettingsShell.value
    }, emit)

    const shellStore = useShellStore()
    const { fullLoader } = storeToRefs(shellStore)

    return {
      showContent,
      micro,
      showTopbar,
      topbarRef,
      topbarEnv,
      resetKey,
      settingsShell,
      settingsItemId,
      updateSettingsShellState,
      updateSettingsShellItemId,
      hasSettingsShell,
      fullLoader
    }
  },
  data () {
    return {
      primaryColor: colors.brand01
    }
  },
  methods: {
    onClickLogout () {
      if (this.showTopbar) {
        this.$refs.topbarRef.logout()
      } else {
        const auth = new Auth()
        auth.redirectLogout()
      }
    },
    onClickNav (item) {
      if (item.clickEvent) {
        const arg = { detail: item.clickEventDetail ? item.clickEventDetail : item }
        window.dispatchEvent(new CustomEvent(item.clickEvent, arg))
      }
      if (!item.url) return
      if (item.url.startsWith('/scorecards')) return
      if (item.url.startsWith('http')) this.showContent = false
      else this.micro.changeRoute(item.url)
    },
    setResetKey () {
      this.resetKey++
    }
  }
}
</script>
